import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Menu, User, Search as SearchIcon } from 'lucide-react';
import { Sheet, SheetContent, SheetTrigger, SheetHeader, SheetTitle, SheetDescription } from './ui/sheet';
import MegaMenu from './MegaMenu';
import { useI18n } from '../context/I18nContext';

const MobileBottomNav = () => {
  const { t } = useI18n();
  const loc = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  // Don't render in admin or vendor dashboards
  if (loc.pathname.startsWith('/admin') || loc.pathname.startsWith('/vendor/dashboard')) return null;

  const itemClass = (active) =>
    `flex flex-1 flex-col items-center justify-center gap-0.5 py-2 text-[10px] transition-colors ${
      active ? 'text-[#ee5e23]' : 'text-gray-600 dark:text-gray-300'
    }`;

  const isActive = (path) => loc.pathname === path;

  return (
    <nav
      className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white dark:bg-[#0b1220] border-t border-gray-200 dark:border-gray-800 shadow-[0_-1px_8px_rgba(0,0,0,0.05)]"
      data-testid="mobile-bottom-nav"
    >
      <div className="grid grid-cols-4">
        <Link to="/" className={itemClass(isActive('/'))} data-testid="bottom-nav-home">
          <Home className="w-5 h-5" /> {t('nav.home')}
        </Link>

        <Sheet open={menuOpen} onOpenChange={setMenuOpen}>
          <SheetTrigger asChild>
            <button className={itemClass(false)} data-testid="bottom-nav-categories">
              <Menu className="w-5 h-5" /> {t('nav.categories')}
            </button>
          </SheetTrigger>
          <SheetContent side="left" className="w-[88%] max-w-sm p-0 overflow-y-auto" data-testid="mobile-mega-menu">
            <SheetHeader>
              <SheetTitle className="sr-only">{t('nav.categories')}</SheetTitle>
              <SheetDescription className="sr-only">Browse all categories</SheetDescription>
            </SheetHeader>
            <div className="p-4 border-b border-gray-200 dark:border-gray-800">
              <h2 className="text-lg font-bold text-[#2c54b2] dark:text-orange-400">{t('nav.categories')}</h2>
            </div>
            <div onClick={(e) => { if (e.target.closest('a')) setMenuOpen(false); }}>
              <MegaMenu variant="drawer" />
            </div>
          </SheetContent>
        </Sheet>

        <Link to="/search" className={itemClass(loc.pathname.startsWith('/search'))} data-testid="bottom-nav-search">
          <SearchIcon className="w-5 h-5" /> {t('nav.search')}
        </Link>
        <Link to="/account" className={itemClass(isActive('/account'))} data-testid="bottom-nav-account">
          <User className="w-5 h-5" /> {t('nav.account')}
        </Link>
      </div>
    </nav>
  );
};

export default MobileBottomNav;
